import { render, staticRenderFns } from "./ImsProfitLoss.vue?vue&type=template&id=ac8c519e&scoped=true&"
import script from "./ImsProfitLoss.vue?vue&type=script&lang=js&"
export * from "./ImsProfitLoss.vue?vue&type=script&lang=js&"
import style0 from "./ImsProfitLoss.vue?vue&type=style&index=0&id=ac8c519e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8c519e",
  null
  
)

export default component.exports